// material
import { Paper, Typography } from '@mui/material';
import type { PaperProps } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

type SearchNotFoundProps = PaperProps & { searchQuery?: string };

export default function SearchNotFound({
  searchQuery = '',
  ...other
}: SearchNotFoundProps) {
  const { t } = useTranslation();
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {t('search-bar.not-found')}
      </Typography>
      <Typography variant="body2" align="center">
        <Trans
          i18nKey="search-bar.no-results-for-query"
          values={{ query: searchQuery }}
          components={{ bold: <strong /> }}
        />
      </Typography>
    </Paper>
  );
}
